import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { TranslateModule } from '@ngx-translate/core';
import { StoreModule } from '@ngrx/store';

import { CoreModule } from '@ridango/core';

import { NotificationAction, NotificationFacade, notificationReducer, NOTIFICATION_STATE_KEY } from './+state';
import { BasicErrorNotificationComponent } from './components/basic-error-notification/basic-error-notification.component';
import { BasicInformationNotificationV2Component } from './components/basic-information-notification-v2/basic-information-notification-v2.component';
import { BasicInformationNotificationComponent } from './components/basic-information-notification/basic-information-notification.component';
import { BasicNotificationElementComponent } from './components/basic-notification-element/basic-notification-element.component';
import { BasicNotificationsContainerComponent } from './components/basic-notifications-container/basic-notifications-container.component';
import { BasicSuccessNotificationComponent } from './components/basic-success-notification/basic-success-notification.component';
import { GroupedNotificationsContainerComponent } from './components/grouped-notifications-container/grouped-notifications-container.component';

@NgModule({
    imports: [
        CommonModule,
        CoreModule,
        TranslateModule,
        StoreModule.forFeature(NOTIFICATION_STATE_KEY, notificationReducer)
    ],
    providers: [NotificationAction, NotificationFacade],
    declarations: [
        BasicNotificationsContainerComponent,
        BasicErrorNotificationComponent,
        BasicSuccessNotificationComponent,
        BasicInformationNotificationComponent,
        BasicNotificationElementComponent,
        BasicInformationNotificationV2Component,
        GroupedNotificationsContainerComponent
    ],
    exports: [
        BasicNotificationsContainerComponent,
        BasicErrorNotificationComponent,
        BasicSuccessNotificationComponent,
        BasicInformationNotificationComponent,
        BasicNotificationElementComponent,
        BasicInformationNotificationV2Component,
        GroupedNotificationsContainerComponent
    ]
})
export class NotificationsModule {}
